import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { Box, ButtonV2 } from '@bridebook/ui';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';
import { renderHtml } from '@bridebook/web/app-shared/components/articles/render-html';
import SearchBar from '@bridebook/web/app-shared/components/articles/search-bar/search-bar';
import componentStyles from './article-tool-header.style';

interface IProps {
  title?: string;
  description?: string;
}

const ArticlesToolHeader = ({ title, description }: IProps) => {
  const { t } = useTranslation('articles');
  const isMobile = useSelector(getIsMobile);
  const styles = componentStyles();
  const market = useMarket();

  // processing both otherwise & is rendered as &amp;
  const tagName = renderHtml({ htmlContent: title, market });
  const tagDescription = renderHtml({ htmlContent: description, market });
  return (
    <Box style={styles.wrapper}>
      <Box style={styles.textWrapper}>
        <Box as="h1" style={styles.title}>
          {tagName || t('find.inspiration.title.adviceAndGuidance')}
        </Box>
        <Box style={styles.subTitle}>{tagDescription || t('find.inspiration.description')}</Box>
      </Box>
      {isMobile && <SearchBar />}
      {!isMobile && (
        <Box style={styles.hubAd}>
          {!isMobile && (
            <img
              style={styles.img}
              src={`${IMAGES_BASE_URL}/assets/article/main_banner.png`}
              alt=""
            />
          )}
          <Box style={styles.adText}>
            <Box mb={isMobile ? 0 : 2}>
              {!isMobile && <Box style={styles.adTitle}>{t('appBanner.title')}</Box>}
              <Box style={styles.adSubTitle}>{t('adSubtitle')}</Box>
            </Box>
            <SignupLink style={styles.startPlanningBtn}>
              <ButtonV2 variant="primary" size="small">
                {t('start.planning')}
              </ButtonV2>
            </SignupLink>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ArticlesToolHeader;
